export type Testimonial = {
  quote: string;
  name: string;
  age: number;
  role: string;
  location: string;
  avatar: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      "Before this, I was rebuilding every prenatal session from scratch — pulling exercises from old notes and rewriting plans late at night. Having the workouts organized by week made my prenatal sessions much easier to prepare. I check the exercises, sets, reps and modifications and already have a clear starting point before my client even walks in.",
    name: "Emily Carter",
    age: 32,
    role: "Personal Trainer",
    location: "Austin, United States",
    avatar: "https://cdn.magicpatterns.com/patterns/generated-images/3c4431e1-a9bf-4f8b-92f4-27f7233a4a28.jpg",
  },
  {
    quote:
      "I coach two clients who are only a few weeks apart, and their sessions look nothing alike. One needed a higher starting position on her hinges, the other needed a different stance for split squats. The modification options helped me keep the same training goal even when they needed completely different exercise setups.",
    name: "Hannah Mitchell",
    age: 37,
    role: "Strength & Conditioning Coach",
    location: "Toronto, Canada",
    avatar: "https://cdn.magicpatterns.com/patterns/generated-images/b0417fb2-92f2-4d68-af1c-0fc17794610f.jpg",
  },
  {
    quote:
      "Between group classes and private clients, my planning time is limited. Now I have three sessions organized for every week and adjust the exercise variation depending on how my client feels that day. If the RPE feels higher than planned, I know exactly where to look.",
    name: "Sophie Bennett",
    age: 29,
    role: "Fitness Instructor",
    location: "Manchester, United Kingdom",
    avatar: "https://cdn.magicpatterns.com/patterns/generated-images/32e9bb91-6baf-4036-9b70-cf9b63b5398e.jpg",
  },
  {
    quote:
      "Mid-session substitutions were always where I lost time. The exercise library and visual adaptation guide make substitutions much easier during real sessions — I find the alternative, compare the setup and keep the session moving without breaking my client’s focus.",
    name: "Laura McKenzie",
    age: 41,
    role: "Personal Trainer",
    location: "Sydney, Australia",
    avatar: "https://cdn.magicpatterns.com/patterns/generated-images/ab52c041-ab0e-4067-bb5c-05d48672639f.jpg",
  },
  {
    quote:
      "My tracking used to live in a notebook and two different apps. With the progress tracker, I can track loads, RPE and modifications for every client while keeping the movements that are still working well. My check-ins feel far more organized and professional.",
    name: "Rachel Thompson",
    age: 35,
    role: "Prenatal Fitness Coach",
    location: "Denver, United States",
    avatar: "https://cdn.magicpatterns.com/patterns/generated-images/c53ae77a-79aa-4257-bdfa-32d2d65fe67a.jpg",
  },
];
